"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImgStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _imageUploaderTheme = require("./imageUploaderTheme");
const ImgStyled = (0, _styled.default)("img")`
    width: 100%;
    height: 100%;
    border-radius: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _imageUploaderTheme.imageUploaderTheme.image.radius(themeMode);
}};
    object-fit: ${props => props.objectFit};
    ${props => props.isDisabled ? "opacity: 0.4;" : ""}
    ${props => props.isDisabled ? "filter: alpha(opacity=40);" : ""}
`;
exports.ImgStyled = ImgStyled;
//# sourceMappingURL=ImgStyled.js.map